import type { CssCustomPropertyColor, CssCustomPropertyFont } from '@libs/ui';

export const enum BracketType {
  Round = 'round',
  Square = 'square',
  Curly = 'curly',
  None = 'none',
}

export interface RelativeMoneyFormatterData {
  price: number;
  basePrice: number;
  currency: string;
  font: CssCustomPropertyFont;
  color: CssCustomPropertyColor;
  bracketType: BracketType;
}
